import {
  MessagesSquare,
  House,
  LayoutDashboard,
  Waypoints,
  Rss,
  Shield,
  FileText,
} from "lucide-react";

/**
 * Canonical section definitions used by both the sidebar and the navbar.
 *
 * • `path`        – route segment (doubles as currentAppPage value)
 * • `label`       – human-readable name
 * • `Icon`        – Lucide component (capitalized for JSX usage)
 * • `hasSubItems` – whether the section has an expandable portal slot
 */
export const SECTION_DEFS = [
  { path: "/home", label: "Home", Icon: House, hasSubItems: false },
  { path: "/chat", label: "Chat", Icon: MessagesSquare, hasSubItems: true },
  { path: "/wiki", label: "Wiki", Icon: LayoutDashboard, hasSubItems: true },
  { path: "/graph", label: "Graph", Icon: Waypoints, hasSubItems: true },
  { path: "/apts", label: "APTs", Icon: Shield, hasSubItems: false },
  { path: "/reports", label: "Reports", Icon: FileText, hasSubItems: true },
  { path: "/feed", label: "Feed", Icon: Rss, hasSubItems: true },
];

/**
 * Same data but shaped for MainLeftSidebar's `sections` prop
 * (uses `icon` as a JSX element with strokeWidth={1}, not `Icon` as a component).
 */
export const SIDEBAR_SECTIONS = SECTION_DEFS.map((s) => ({
  path: s.path,
  label: s.label,
  icon: <s.Icon strokeWidth={1} />,
  hasSubItems: s.hasSubItems,
}));
